import API from '../api';

export const getPublicReportSettings = () =>
  API.get('/public/report-settings').then((r) => r.data);

export const getAdminReportSettings = () =>
  API.get('/admin/report-settings').then((r) => r.data);

export const saveAdminReportSettings = (payload) =>
  API.put('/admin/report-settings', payload).then((r) => r.data);
